import { Route } from '~/routes/types';
import { SETTINGS_ROUTE } from '~/routes/private/settings/constants';
import Settings from '~/pages/settings';

export const settings: Route = {
  to: SETTINGS_ROUTE,
  exact: true,
  component: Settings
};
